<template>
  <div
    class="flex flex-col gap-8"
    :class="{
      'text-left': alignment === 'left' || !alignment,
      'text-center': alignment === 'center',
    }"
  >
    <!-- 
  This BlockRenderer should not use lazy hydration since ModularCards can be lazily hydrated. 
  A nested lazy hydration will trigger bugs and make the page unresponsive.
  -->
    <BlockRenderer
      v-for="{ id, props, type, hiddenDevices } in slots"
      :id
      :key="id"
      :block-position="blockPosition || 1"
      :hidden-devices
      hydration-mode="eager"
      :props
      :tracking="{
        position: cardPosition ?? 1,
        ...(blockTitle && { blockTitle }),
      }"
      :type
      :with-bottom-margin="false"
    />
  </div>
</template>

<script lang="ts" setup>
import type { ModularCardSectionAlignment } from '@backmarket/http-api/src/api-specs-content/models/modular-card'
import type { Maybe } from '@backmarket/utils/types/Maybe'

import type { _Block } from '../../models/block'
import BlockRenderer from '../../shared-components/BlockRenderer/BlockRenderer.vue'

export type ModularCardSection = {
  alignment?: Maybe<ModularCardSectionAlignment>
  slots: Array<
    | _Block<'Button'>
    | _Block<'Buttons'>
    | _Block<'Media'>
    | _Block<'ModularCardImage'>
    | _Block<'ListItem'>
    | _Block<'RichText'>
  >
  cardPosition?: number
  blockPosition?: number
  blockTitle?: Maybe<string>
}

defineProps<ModularCardSection>()
</script>
